import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { cyberColors, CYBER_FONT, mutedTextSx } from "../../styles/cyberTheme";

function formatRow(item) {
    const stat = item.stat || {};
    return {
        id: item.id,
        name: item.name_zh || item.name_en || item.code,
        participant_count: stat.participant_count ?? 0,
        play_duration_hours: stat.play_duration
            ? (Number(stat.play_duration) / 3600).toFixed(2)
            : "0.00",
        avg_score: stat.avg_score
            ? parseFloat(stat.avg_score).toFixed(2)
            : "0.00",
        max_score: stat.max_score ?? "—",
    };
}

const headerCellSx = {
    fontFamily: CYBER_FONT,
    fontWeight: 700,
    color: cyberColors.cyan,
    borderBottom: `1px solid ${cyberColors.purple.borderMedium}`,
    fontSize: "13px",
    whiteSpace: "nowrap",
    py: 1,
    background: `${cyberColors.purple.glow}`,
};

const bodyCellSx = {
    fontFamily: CYBER_FONT,
    color: cyberColors.text.light,
    borderBottom: `1px solid ${cyberColors.purple.border}`,
    fontSize: "13px",
    py: 0.75,
};

export default function MemberSkillStatTable({ data = [] }) {
    const rows = data.map(formatRow);

    return (
        <TableContainer sx={{ maxHeight: "100%" }}>
            <Table size="small" stickyHeader>
                <TableHead >
                    <TableRow sx={{ background: "linear-gradient(90deg, rgba(130,60,255,0.15) 0%, rgba(0,229,255,0.05) 100%)" }}>
                        <TableCell sx={headerCellSx}>項目名稱</TableCell>
                        <TableCell align="right" sx={headerCellSx}>登入人次</TableCell>
                        <TableCell align="right" sx={headerCellSx}>累積時數</TableCell>
                        <TableCell align="right" sx={headerCellSx}>平均分數</TableCell>
                        <TableCell align="right" sx={headerCellSx}>最高分數</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow
                            key={row.id ?? index}
                            sx={{
                                background:
                                    index % 2 === 0
                                        ? "linear-gradient(90deg, rgba(130,60,255,0.15) 0%, rgba(0,229,255,0.05) 100%)"
                                        : "rgba(10, 5, 30, 0.4)",
                            }}
                        >
                            <TableCell sx={bodyCellSx}>{row.name}</TableCell>
                            <TableCell align="right" sx={bodyCellSx}>{row.participant_count}</TableCell>
                            <TableCell align="right" sx={bodyCellSx}>{row.play_duration_hours}</TableCell>
                            <TableCell align="right" sx={bodyCellSx}>{row.avg_score}</TableCell>
                            <TableCell align="right" sx={bodyCellSx}>{row.max_score}</TableCell>
                        </TableRow>
                    ))}
                    {rows.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={5} sx={{ ...mutedTextSx, border: 0, textAlign: "center", py: 3 }}>
                                暫無運動數據
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
